module.exports = __webpack_public_path__ + "img/home-game-button.abbb808f.png";